export const USER_STATUS = {
  INITIAL: "initial",
  INVITED: "invited",
  ACTIVE: "active",
  INACTIVE: "inactive",
}

export const USER_TRAINING_STATUS = {
  NONE: "none",
  IN_PROGRESS: "in_progress",
  OVERDUE: "overdue",
  COMPLETE: "complete",
}

export const USER_TRAINING_MODULE_STATUS = {
  INCOMPLETE: 1,
  IN_PROGRESS: 2,
  COMPLETE: 3,
}

export const USER_TRAINING_ASSESSMENT_STATUS = {
  NONE: "none",
  SCHEDULED: "scheduled",
  COMPETENT: "competent",
  NEEDS_TRAINING: "needs_training",
  TRAINER: "trainer",
}

export const USER_TRAINING_ASSESSMENT_STATUS_LABELS = {
  [USER_TRAINING_ASSESSMENT_STATUS.NONE]: "None",
  [USER_TRAINING_ASSESSMENT_STATUS.SCHEDULED]: "Scheduled",
  [USER_TRAINING_ASSESSMENT_STATUS.COMPETENT]: "Competent",
  [USER_TRAINING_ASSESSMENT_STATUS.NEEDS_TRAINING]: "Needs training",
  [USER_TRAINING_ASSESSMENT_STATUS.TRAINER]: "Trainer",
}

export const USER_ACCREDITATIONS_STATUS = {
  NONE: "none",
  AWAITING: "awaiting",
  WARNING: "warning",
  EXPIRED: "expired",
  COMPLIANT: "compliant",
}

export const NOTIFICATION_TYPE = {
  PROCESS: 1,
  TASK: 2,
  KNOWLEDGE: 4,
  POST: 8,
  JOB: 16,
  ACTION: 32,
  TRAINING: 64,
  ACCREDITATION: 128,
}

export const NOTIFY_TYPE = {
  NONE: 0,
  NOTIFICATION: 1,
  EMAIL: 2,
}

export const CRON_JOB_TYPE = {
  JOB_GENERATE_LOCATION_DAY_JOBS: 0,
  JOB_STATUS_NOTIFICATION: 1,
}

export const PRIORITY = {
  NONE: 0,
  LOW: 1,
  STANDARD: 2,
  MEDIUM: 4,
  HIGH: 8,
}

export const PROCESS_REPEAT = {
  NEVER: 0,
  DAILY: 1,
  WEEKLY: 2,
  FORTNIGHTLY: 4,
  MONTHLY: 8,
  YEARLY: 9,
  ADHOC: 100,
}

export const SCHEDULE_FILTER = {
  ONCE: { label: "One-off", type: PROCESS_REPEAT.NEVER },
  DAILY: { label: "Daily", type: PROCESS_REPEAT.DAILY, frequency: 1 },
  WEEKLY: { label: "Weekly", type: PROCESS_REPEAT.WEEKLY, frequency: 1 },
  FORTNIGHTLY: { label: "Fortnightly", type: PROCESS_REPEAT.FORTNIGHTLY, frequency: 1 },
  MONTHLY: { label: "Monthly", type: PROCESS_REPEAT.MONTHLY, frequency: 1 },
  QUARTERLY: { label: "Quarterly", type: PROCESS_REPEAT.QUARTERLY, frequency: 3 },
  YEARLY: { label: "Yearly", type: PROCESS_REPEAT.YEARLY, frequency: 1 },
  ADHOC: { label: "Adhoc", type: PROCESS_REPEAT.ADHOC },
}

export const SCHEDULE_FILTERS = Object.keys(SCHEDULE_FILTER).map((key) => ({
  key: key.toLowerCase(),
  ...SCHEDULE_FILTER[key],
}))

export const NON_RECURRING_SCHEDULE_FILTERS = Object.keys(SCHEDULE_FILTER)
  .filter((key) => ![PROCESS_REPEAT.NEVER, PROCESS_REPEAT.ADHOC].includes(SCHEDULE_FILTER[key].type))
  .map((key) => ({
    key: key.toLowerCase(),
    ...SCHEDULE_FILTER[key],
  }))

export const JOB_PINNING = {
  NONE: 0,
  COMPLETED: 1,
  NEXT_INSTANCE: 2,
  MINUTES: 10,
  HOURS: 11,
  DAYS: 12,
}

export const PROCESS_SET = {
  ACTIVE_RECURRING: "active-recurring",
  ACTIVE_ONEOFF: "active-oneoff",
  ACTIVE_ADHOC: "active-adhoc",
  INACTIVE_RECURRING: "inactive-recurring",
  INACTIVE_ONEOFF: "active-oneoff",
  INACTIVE_ADHOC: "inactive-adhoc",
}

export const TASK_RESPONSE_TYPE = {
  NONE: 0,
  NUMBER: 1,
  TEXT: 2,
  DATE: 4,
  PHOTOS: 8,
  YES_NO_NA: 16,
  NUMBER_RATING_5: 32,
  NUMBER_RATING_10: 64,
}

export const KNOWLEDGE_CONTENT_TYPE = {
  TEXT: 0,
  IMAGE: 1,
  FILES: 2,
  NOTE: 4,
  NOTE_IMPORTANT: 8,
  NOTE_DANGER: 16,
  VIDEO: 32,
}

export const ORGANISATION_INDUSTRIES = [
  "Accommodation",
  "Administrative and Support Services",
  "Agriculture, Forestry and Fishing",
  "Arts and Recreation Services",
  "Aviation and Marine",
  "Construction",
  "Education and Training",
  "Electricity, Gas, Water and Waste Services",
  "Financial and Insurance Services",
  "Healthcare",
  "Hospitality",
  "Information Media and Telecommunications",
  "Manufacturing",
  "Mining",
  "Professional, Scientific and Technical Services",
  "Public Administration and Safety",
  "Rental, Hiring and Real Estate Services",
  "Retail Trade",
  "Transport",
  "Wholesale Trade",
  "Other Services",
]

export const BILLING_TYPE = {
  PER_USER: "per_user",
  PER_LOCATION: "per_location",
  FLAT_RATE: "flat_rate",
}

export const DEVICE_TYPE = {
  UNKNOWN: 0,
  PHONE: 1,
  TABLET: 2,
  DESKTOP: 3,
  TV: 4,
}

export const DEVICE_POSTMESSAGE_TYPE = {
  IMAGES: 0,
  DOWNLOAD: 1,
}

export const IDENTITY_PROVIDER_BEHAVIOUR = {
  NORMAL: "normal",
  AZURE_AD: "azure_ad",
}

export const OPENID_PROMPT = {
  DEFAULT: "default",
  NONE: "none",
  LOGIN: "login",
  CONSENT: "consent",
  SELECT_ACCOUNT: "select_account",
}

export const SENSOR_SAMPLE_TYPE = {
  TEMPERATURE: 1,
  HUMIDITY: 2,
  TEMPERATURE_ADHOC: 3,
  CARBON_DIOXIDE: 4,
}

export const TIMESHEET_STATUS = {
  NOT_SCHEDULED: "not_scheduled",
  SCHEDULED: "scheduled",
  ACTIVE: "active",
  PAUSED: "paused",
  ENDED: "ended",
}

export const CALENDAR_ENTRY_TYPE = {
  NORMAL: "normal",
  PINNED_UNTIL: "pinned_until",
  FUTURE: "future",
}

export const TRIGGER_TYPE = {
  SCHEDULE: "schedule",
  EVENT: "event",
}

export const TRIGGER_TARGET_TYPE = {
  NOTIFY_USERS: "notify_users",
  NOTIFY_EMAILS: "notify_emails",
  INTEGRATION: "integration",
}

export const TRIGGER_TARGET_TYPE_LABELS = {
  [TRIGGER_TARGET_TYPE.NOTIFY_USERS]: "Send a communication to Operandio users",
  [TRIGGER_TARGET_TYPE.NOTIFY_EMAILS]: "Send a communciation to external email address(es)",
  [TRIGGER_TARGET_TYPE.INTEGRATION]: "Raise an integration webhook",
}

export const TRIGGER_SCHEDULE_SOURCE_OUTPUT_TYPE = {
  MONTHLY_SUMMARY: "monthly_summary",
  WEEKLY_SUMMARY: "weekly_summary",
  YESTERDAY_SUMMARY: "yesterday_summary",
  INTRADAY_SUMMARY: "intraday_summary",
}

export const TRIGGER_SCHEDULE_SOURCE_OUTPUT_TYPE_LABELS = {
  [TRIGGER_SCHEDULE_SOURCE_OUTPUT_TYPE.MONTHLY_SUMMARY]: "Summary of previous calendar months activity",
  [TRIGGER_SCHEDULE_SOURCE_OUTPUT_TYPE.WEEKLY_SUMMARY]: "Summary of the past 7 days of activity",
  [TRIGGER_SCHEDULE_SOURCE_OUTPUT_TYPE.YESTERDAY_SUMMARY]: "Summary of the previous days activity",
  [TRIGGER_SCHEDULE_SOURCE_OUTPUT_TYPE.INTRADAY_SUMMARY]: "Intraday summary of activity",
}

export const TRIGGER_NOTIFY_METHOD = {
  IN_APP: "in_app",
  EMAIL: "email",
  SMS: "sms",
  PUSH: "push",
}

export const TRIGGER_NOTIFY_METHOD_LABELS = {
  [TRIGGER_NOTIFY_METHOD.IN_APP]: "In-application",
  [TRIGGER_NOTIFY_METHOD.EMAIL]: "Email",
  [TRIGGER_NOTIFY_METHOD.SMS]: "SMS",
  [TRIGGER_NOTIFY_METHOD.PUSH]: "Push notification",
}

export const EVENT_NAME = {
  ACTION_CREATED: "action_created",
  ACTION_UPDATED: "action_updated",

  JOB_COMPLETED: "job_completed",
  JOB_STEP_COMPLETED: "job_step_completed",
  JOB_OVERDUE: "job_overdue",
}
